export const BOUNCE_ANIMATION_DURATION_MILISECONDS = 400;
export const BOUNCE_PERCENTAGE_OFFSET = 12;